<template>
  <div class="faq-section-container">
    <page-content-creator
      itemid="faq-list-header"
      pos="top"
      name="faq-list-header"
      allowed-widgets="carousel, vimeo-video"
      class="faq-list-header"
    />
    <b-container>
      <b-row>
        <b-col>
          <page-content-creator
            itemid="faqs-list"
            pos="top"
          />
        </b-col>
      </b-row>
      <b-row class="faq-section">
        <b-col>
          <faq-list :faqs="faqs" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <page-content-creator
            itemid="faqs-list"
            pos="bottom"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import { asyncLoader, pageMixin } from '../page-layout-faqs-list-common'
import FaqList from './faq-list'

export default {
  name: 'page-layout-faqs-list',
  components: {
    FaqList
  },
  mixins: [
    pageMixin
  ],
  asyncData: (args) => args.store.dispatch('promisePool', {
    name: 'page-layout-faqs-list',
    resolve: () => asyncLoader(args)
  })
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
.faq-list-header {
 ::v-deep .swiper-container{
  margin-bottom:3em;
  }
}
.faq-section-container {
  .faq-section {
    margin: 3em 0 3em 0;
  }
}

</style>
